import request from '@/utils/request';
// export const getMyProjectList = (params: any) =>
//   request({
//     url: 'Project/myCreateProjectList',
//     method: 'GET',
//     params
//   });
export const getProjectList = (params: any) =>
  request({
    url: 'Project/projectList',
    method: 'GET',
    params
  });
export const getAllProjectList = (params: any) =>
  request({
    url: 'Project/allProjectList',
    method: 'GET',
    params
  });
export const addProject = (data: any) =>
  request({
    url: 'Project/project',
    method: 'POST',
    data
  });
export const editorProject = (data: any) =>
  request({
    url: 'Project/project',
    method: 'PUT',
    data
  });
export const delProject = (data: any) =>
  request({
    url: 'Project/project',
    method: 'DELETE',
    data
  });
export const startProject = (data: any) =>
  request({
    url: 'Project/startProject',
    method: 'PUT',
    data
  });
export const completeProject = (data: any) =>
  request({
    url: 'Project/completeProject',
    method: 'PUT',
    data
  });
export const getProjectTaskCollect = (params: any) =>
  request({
    url: 'Project/projectTaskCollect',
    method: 'GET',
    params
  });
export const getProjectTaskList = (params: any) =>
  request({
    url: 'Project/projectTaskList',
    method: 'GET',
    params
  });

export const addProjectTask = (data: any) =>
  request({
    url: 'Project/projectTask',
    method: 'POST',
    data
  });
export const editorProjectTask = (data: any) =>
  request({
    url: 'Project/projectTask',
    method: 'PUT',
    data
  });
export const delProjectTask = (data: any) =>
  request({
    url: 'Project/projectTask',
    method: 'DELETE',
    data
  });
export const startProjectTask = (data: any) =>
  request({
    url: 'Project/startProjectTask',
    method: 'PUT',
    data
  });
export const completeProjectTask = (data: any) =>
  request({
    url: 'Project/completeProjectTask',
    method: 'PUT',
    data
  });

export const getProjectDetail = (params: any) =>
  request({
    url: 'Project/projectDetail',
    method: 'GET',
    params
  });
export const getProjectTaskCollectDetail = (params: any) =>
  request({
    url: 'Project/projectTaskCollectDetail',
    method: 'GET',
    params
  });
export const getProjectTaskDetail = (params: any) =>
  request({
    url: 'Project/projectTaskDetail',
    method: 'GET',
    params
  });
export const setUser = (data: any) =>
  request({
    url: 'Project/setUser',
    method: 'POST',
    data
  });
export const getUserList = (params: any) =>
  request({
    url: 'Project/userList',
    method: 'get',
    params
  });
export const addResource = (data: any) =>
  request({
    url: 'Project/projectResource',
    method: 'POST',
    data
  });
export const delResource = (data: any) =>
  request({
    url: 'Project/projectResource',
    method: 'DELETE',
    data
  });
export const addProjectQuestion = (data: any) =>
  request({
    url: 'Project/projectQuestion',
    method: 'POST',
    data
  });
export const getProjectQuestionList = (params: any) =>
  request({
    url: 'Project/projectQuestionList',
    method: 'get',
    params
  });
export const editUser = (data: any) =>
  request({
    url: 'Project/editUser',
    method: 'PUT',
    data
  });
export const getRecycleProjectList = (params: any) =>
  request({
    url: 'Project/recycleProjectList',
    method: 'get',
    params
  });
export const projectRecover = (data: any) =>
  request({
    url: 'Project/projectRecover',
    method: 'PUT',
    data
  });
export const projectReallyDelete = (data: any) =>
  request({
    url: 'Project/projectReallyDelete',
    method: 'DELETE',
    data
  });
export const getProjectTaskProgressList = (params: any) =>
  request({
    url: 'Project/projectTaskProgressList',
    method: 'get',
    params
  });
